import { CSSObject } from "@emotion/react";
import {
  AngelouCSS,
  ButtonStyleOverrides,
  constants,
  typographyStyles,
} from "@newsela/angelou";

const { fontFamily, fontSize } = typographyStyles;
const {
  colors: { ui },
} = constants;

export const addRemoveButtonCss: ButtonStyleOverrides<AngelouCSS> = {
  root: {
    background: "none",
    color: ui.core[700],
    ...fontFamily.circular,
    fontWeight: 400,
    ...fontSize.textM,
    padding: "16px",
    marginRight: "-16px",

    "&:hover": {
      background: "none",
    },

    "&[disabled]": {
      background: "none",
    },
  },
};

export const addedCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: "8px",
  alignItems: "center",
  ...fontSize.textM,
  color: ui.black[700],
  padding: "16px",
  marginRight: "-16px",
};
